import language from "../../dictionary";
import {
  EPaywallErrorCode,
  ERequestDownloadErrorCode,
  EValidateSubscriptionErrorCode,
  ERequestOrderErrorCode,
  EConfirmDownloadErrorCode,
  EValidateSubscriptionTokenErrorCode,
  EErrorOrigin,
  EErrorType,
  EErrorName,
} from "../enums";

const AUTHENTICATION_ERROR_CODES = [
  "E3",
  "E5",
  "E6",
  "E7",
  "E14",
  "E15",
  "E17",
  "E20",
  "E21",
  "E26",
  "E29",
];

export function isAuthenticationAuthorizationError(error) {
  return error && error.name === EErrorName.AUTHENTICATION_AUTHORISATION;
}

//const systemUnavailableErrors = ["E1", "E4", "E9", "E13", "E15"];
export default class AuthenticationAuthorizationError extends Error {
  constructor(
    context,
    origin,
    code = undefined,
    type = undefined,
    message = ""
  ) {
    super(message);

    this.details = context && context.data ? context.data : context;
    this.code = this.getCode(code);
    this.origin = origin;
    this.type =
      origin === EErrorOrigin.REQUESTDOWNLOAD
        ? this.getRequestDownloadErrorType()
        : type;

    this.name = EErrorName.AUTHENTICATION_AUTHORISATION;

    this.initialize();
  }

  get code() {
    return this.code;
  }

  get message() {
    return this.message;
  }
  set message(message) {
    this.message = message;
  }

  get details() {
    return this.details;
  }
  set details(details) {
    this.details = details;
  }

  get origin() {
    return this.origin;
  }

  get type() {
    return this.type;
  }

  set type(type) {
    this.type = type;
  }

  getRequestDownloadErrorType = () => {
    if (!this.details || !this.details.StatusMessage) {
      return;
    }

    const errorType = AUTHENTICATION_ERROR_CODES.some(
      (code) => code === this.details.StatusMessage
    )
      ? EErrorType.AUTHENTICATION
      : EErrorType.AUTHORIZATION;

    return errorType;
  };

  getCode = (code) => {
    if (this.details && typeof this.details.StatusMessage === "string") {
      return this.details.StatusMessage;
    }

    return code;
  };

  hasUnsuccessfullStatus = () => {
    return (
      this.details &&
      this.details.StatusMessage &&
      this.details.StatusMessage != null &&
      this.details.StatusMessage.toLowerCase() != "ok"
    );
  };

  getErrorMessageFromStatusMessage = (StatusMessage) => {
    if (this.details && this.details.CustomStatusMessage) {
      return `${this.details.CustomStatusMessage}`;
    }
    return this.hasUnsuccessfullStatus(this.details)
      ? `${language[StatusMessage]} (${StatusMessage})`
      : `${language[StatusMessage]}`;
  };

  getErrorMessageFromTranslationConfig = (config) => {
    if (this.details && this.details.CustomStatusMessage) {
      return `${this.details.CustomStatusMessage}`;
    }
    return this.hasUnsuccessfullStatus(this.details)
      ? `${config} (${this.details.StatusMessage})`
      : `${config}`;
  };

  handleFrontEndErrors = () => {
    switch (this.origin) {
      case EErrorOrigin.VALIDATESUBSCRIPTION:
        this.handleValidateSubscriptionFrontEndErrors();
        break;

      case EErrorOrigin.REQUESTDOWNLOAD:
        this.handleRequestDownloadFrontEndErrors();
        break;

      case EErrorOrigin.CONFIRMDOWNLOAD:
        this.handleConfirmDownloadFrontEndErrors();
        break;

      case EErrorOrigin.REQUESTORDER:
        this.handleRequestOrderFrontEndErrors();
        break;

      case EErrorOrigin.PAYWALL:
        this.handlePaywallFrontEndErrors();
        break;

      default:
        this.handleUnknownError();
        break;
    }
  };

  handleValidateSubscriptionTokenFrontEndErrors = () => {
    switch (this.code) {
      case EValidateSubscriptionTokenErrorCode.CALL_FAILED:
      case EValidateSubscriptionTokenErrorCode.STATUS_NOT_A_STRING:
      case EValidateSubscriptionTokenErrorCode.UNSUCCESSFULL:
      default:
        this.message = this.getErrorMessageFromTranslationConfig(
          language.SSOValidationFailed
        );

        break;
    }
  };

  handlePaywallFrontEndErrors = () => {
    switch (this.code) {
      case EPaywallErrorCode.NOT_ALL_FIELDS_FILLED:
      case EPaywallErrorCode.WRONG_EMAIL:
        this.message = this.hasUnsuccessfullStatus(this.details)
          ? `${language.PleaseFillInAValidEmail} (${this.details.StatusMessage})`
          : `${language.PleaseFillInAValidEmail}`;
        break;
      default:
        this.handleUnknownError();
        break;
    }
  };

  handleValidateSubscriptionFrontEndErrors = () => {
    switch (this.code) {
      case EValidateSubscriptionErrorCode.CALL_FAILED:
      case EValidateSubscriptionErrorCode.STATUS_NOT_A_STRING:
      case EValidateSubscriptionErrorCode.UNSUCCESSFULL:
      default:
        this.message = this.getErrorMessageFromTranslationConfig(
          language.ValidationFailed
        );

        break;
    }
  };

  handleRequestDownloadFrontEndErrors = () => {
    switch (this.code) {
      case ERequestDownloadErrorCode.CALL_FAILED:
      case ERequestDownloadErrorCode.STATUS_NOT_A_STRING:
      case ERequestDownloadErrorCode.UNSUCCESSFULL:
        this.handleUnknownError();
        break;

      default:
        this.message = this.getErrorMessageFromTranslationConfig(
          language.NewspaperCurrentlyUnavailable
        );
        break;
    }
  };

  handleConfirmDownloadFrontEndErrors = () => {
    switch (this.code) {
      case EConfirmDownloadErrorCode.CALL_FAILED:
      case EConfirmDownloadErrorCode.STATUS_NOT_A_STRING:
      case EConfirmDownloadErrorCode.UNSUCCESSFULL:
        this.message = this.getErrorMessageFromTranslationConfig(
          language.NewspaperCurrentlyUnavailable
        );
        break;
      default:
        this.handleUnknownError();
        break;
    }
  };

  handleUnknownError = () => {
    this.message =
      this.hasUnsuccessfullStatus(this.details) &&
      this.details.StatusMessage.toLowerCase() != "ok"
        ? `${language.UnknownError} (${this.details.StatusMessage})`
        : `${language.UnknownError}`;
  };

  //TODO: to be removed when RO call is removed
  handleRequestOrderFrontEndErrors = () => {
    switch (this.code) {
      case ERequestOrderErrorCode.CALL_FAILED:
      case ERequestOrderErrorCode.STATUS_NOT_A_STRING:
      case ERequestOrderErrorCode.UNSUCCESSFULL:
        this.message = this.getErrorMessageFromTranslationConfig(
          language.NewspaperCurrentlyUnavailable
        );
        break;
      default:
        this.handleUnknownError();
        break;
    }
  };

  handleBackendErrors = () => {
    switch (this.code) {
      case "E1":
      case "E4":
      case "E5":
      case "E6":
      case "E7":
      case "E8":
      case "E9":
      case "E11":
      case "E13":
      case "E15":
      case "E18":
      case "E24":
      case "E25":
      case "E26": {
        this.message = this.getErrorMessageFromStatusMessage(
          this.details.StatusMessage
        );
        break;
      }
      default:
        this.handleFrontEndErrors();
        break;
    }
  };

  initialize = () => {
    if (this.origin === EErrorOrigin.VALIDATESUBSCRIPTIONTOKEN) {
      this.handleValidateSubscriptionTokenFrontEndErrors();
    } else {
      this.handleBackendErrors();
    }
  };
}



// WEBPACK FOOTER //
// ./src/common/utilities/errors/authenticationAuthorizationError.js